import { useMutation } from '@tanstack/react-query';

import { submitAttestation, type AttestationBody } from '@/api/attestations';

/**
 * Record an attestation (PLA-1110): the AI Governance acceptance at sign-in,
 * or a goals commitment from the reminder. No retry: a failure is shown where
 * the user is and they retry explicitly.
 */
export const useSubmitAttestation = () =>
  useMutation({
    mutationFn: (body: AttestationBody) => submitAttestation(body),
    retry: false,
  });
